import { Link, useNavigate, useParams } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { Key, useEffect, useRef, useState } from "react";
import Screen from "../../Layouts/Screen/Screen";
import { CheckCircle, Clock, Edit, Heart, MessageCircle, Paperclip, Send, Smile, Trash, XSquare } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS, LIMIT_TEXT_COMMENT } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { useAiMentionLimitBanner } from "../../../hooks/useAiMentionLimit";
import AiLimitBanner from "../../../components/ai-limit-banner";
import EmojiPickerNative from "../../../components/Textarea/Emojis/emoji-picker-native";
import { calculateTime } from "../../../utils/TextManagerTwo";
import { Post as PostType } from "../../../types";
import ViewPost from "../../../components/Post/ViewPost";
import { useMessage } from '../../../global-components/src';
import ImgVerified from "../../../components/imgVerified/ImgVerified";
import NavbarMobile from "../../../components/navbar-mobile/navbar-mobile";
import NavbarPC from "../../../components/navbar-pc/navbar-pc";
import EditPost from "../../../components/Modals/EditPost";
import FormVerifyEmail from "../../../components/FormVerifyEmail/FormVerifyEmail";
import ModalPostLikes from "../PostLikes/ModalPostLikes";
// import ModalPostComments from "../PostLikes/ModalPostComments";
import RepostWithText from "../../../components/Modals/RepostWithText";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import { getImageUser } from "../../../global-components/src/utils/auth";
import ButtonBack from "../../../global-components/src/components/buttons/back";
import ModalCommentsBottom from "../../../components/Modals/comments/comments-bottom";
import ModalComments from "../../../components/Modals/comments/modal-comments";
import { censorText, clearText, verifyLinks } from "../../../global-components/src/utils/text";
import { renderTextWithPhoneMessageLinks } from '../../../utils/phone-message-links';
import PinComment from "../../../components/Post/Config/PinComment";
import { useTranslation } from 'react-i18next';
import AnchoredDropdown, { DropdownItem } from "../../../components/AnchoredDropdown/AnchoredDropdown";

const PostComments = () => {
    const { id: postId } = useParams();
    const [comments, setComments] = useState<any[]>([]);
    const [pinnedCommentIds, setPinnedCommentIds] = useState<number[]>([]);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingResponse, setIsLoadingResponse] = useState<number | null>(null);
    const [isLoadingPost, setIsLoadingPost] = useState(true);
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const { user, fetchUser } = useAuth();
    const minHeight = 20; // Altura mínima inicial
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const [text, setText] = useState("");
    const aiLimitBannerName = useAiMentionLimitBanner(text, user?.id);
    const [disabled, setDisabled] = useState(true);
    const [isEdditing, setIsEdditing] = useState(false);
    const [idCommentEdit, setIdCommentEdit] = useState(0);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [post, setPost] = useState<PostType | null>(null);
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showEmoji, setShowEmoji] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [expandedComments, setExpandedComments] = useState<{ [key: number]: boolean }>({});
    const [responsesOffset, setResponsesOffset] = useState<{ [key: number]: number }>({});
    const [idCommentToResponse, setIdCommentToResponse] = useState<number | null>(null);
    const [userNameCommentToResponse, setUserNameCommentToResponse] = useState<string | null>(null);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [suggestions, setSuggestions] = useState<any>([]);

    const toggleCommentExpansion = (commentId: number) => {
        setIsLoadingResponse(commentId)
        loadResponses(commentId)

        setExpandedComments(prev => ({
            ...prev,
            [commentId]: !prev[commentId]
        }));
        setIsLoadingResponse(null)
    };

    const loadPost = async () => {
        const url = PACOCA_API_URL + `/posts/${postId}`;

        // if (loading) return;

        setIsLoadingPost(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (Array.isArray(data) && data.length > 0) {
                setPost(data[0]); // Pegando o primeiro item do array
            } else if (!Array.isArray(data)) {
                setPost(data); // Se for um objeto
            } else {
                // setEnd(true);
            }
        } catch (err: any) {
            console.error("Failed to load posts:", err);
            setHasMore(false)
            // if (err.response?.status === 401) setError(t("generics.errors.sessionExpired"));
            // if (err.response?.status === 429) setError(t("generics.errors.tooManyRequestsGeneric"));
        } finally {
            setIsLoadingPost(false);
        }
    };

    const updateText = (newText: string) => {
        setText(newText); // Atualiza o estado com o novo texto
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        const screenWidth = window.innerWidth; // Obtém a largura da tela

        if (e.key === "Enter") {
            e.preventDefault(); // Evita o comportamento padrão
            if (e.shiftKey || screenWidth <= 850) {
                setText((prevText) => prevText + "\n"); // Adiciona uma nova linha
            } else if (screenWidth > 850 && text.trim().length > 0) {
                handleSubmitComment(e as any); // Dispara o envio do formulário
            }
        }
    };

    const handleInputTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        setIsLimitExceeded(newText.length > LIMIT_TEXT_COMMENT);
    }

    const handleFocusTextarea = () => {
        const menu = document.querySelector(".menu-cel-input") as HTMLElement;
        if (menu) menu.style.display = "none";
    }


    const handleBlurTextarea = () => {
        const menu = document.querySelector(".menu-cel-input") as HTMLElement;
        if (menu) menu.style.display = "block"; // Oculta o menu em vez de mostrá-lo
    };


    useEffect(() => {
        const body = document.body;
        if (body) body.style.overflow = "hidden";

        return () => {
            if (body) body.style.overflow = "auto";
        };
    }, []);


    const handleClickEmoji = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        setText((prev) => {
            if (prev[start - 1] === ":") return prev;

            const needsSpaceBefore =
                start > 0 && prev[start - 1] !== " " && prev[start - 1] !== "\n";

            const insertText = needsSpaceBefore ? " :" : ":";

            const newText =
                prev.substring(0, start) +
                insertText +
                prev.substring(end);

            setTimeout(() => {
                const pos = start + insertText.length;

                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = pos;

                // 🔥 SIMULA DIGITAÇÃO REAL
                textarea.dispatchEvent(new Event("input", { bubbles: true }));
            }, 0);

            return newText;
        });
    };

    // Função para ajustar a altura dinamicamente
    const adjustTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reseta a altura para calcular corretamente
            const newHeight = Math.max(minHeight, textareaRef.current.scrollHeight); // Garante a altura mínima
            textareaRef.current.style.height = `${newHeight}px`;
        }
    };

    const loadData = async () => {
        if (isLoading || !hasMore || !post?.id) return;

        setIsLoading(true);
        const url = `${PACOCA_API_URL}/posts/comments/${postId}/?limit=${LIMIT_REQUEST_COMMENTS}&offset=${offset}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            if (response.data.comments.length < LIMIT_REQUEST_COMMENTS) setHasMore(false);

            if (offset === 0 && response.data.pinned_comment_ids) {
                setPinnedCommentIds(response.data.pinned_comment_ids.map(Number));
            }

            setComments((prevData) => [...prevData, ...response.data.comments]);
            setOffset((prevOffset) => prevOffset + LIMIT_REQUEST_COMMENTS);
        } catch (error) {
            console.error("Erro ao carregar curtidas:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (idComment: number, isResponse = false, parentCommentId?: number) => {
        const url = `${PACOCA_API_URL}/comments/${idComment}`;

        try {

            if (isResponse && parentCommentId) {
                // Se for uma resposta, remove dentro do responses do comentário pai
                setComments((prevData) =>
                    prevData.map(comment =>
                        comment.id === parentCommentId
                            ? {
                                ...comment,
                                responses: comment.responses.filter((response: { id: number; }) => response.id !== idComment),
                                total_responses: Math.max(0, comment.total_responses - 1) // Garante que não fique negativo
                            }
                            : comment
                    )
                );
            } else {
                // Se for um comentário normal, remove da lista de comments
                setComments((prevData) => prevData.filter(comment => comment.id !== idComment));
            }

            await axios.delete(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

        } catch (err: any) {
            if (err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if (err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

            if (err.status == 401)
                setMessage(t("generics.errors.sessionExpired"), "error");

            if (err.response) {
                setMessage(err.response.data.message || "Erro ao comentar!", "error");
            } else if (err.request) {
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                setMessage("Ocorreu um erro inesperado!", "error");
            }
            console.error(err);
        }
    }

    const handleLike = async (idComment: number, isResponse = false, parentCommentId?: number) => {
        const url = `${PACOCA_API_URL}/comments/like/${idComment}`;

        try {
            setComments((prevComments) =>
                prevComments.map((comment) => {
                    if (isResponse && parentCommentId) {
                        // Se for uma resposta, encontra o comentário pai e atualiza a resposta específica
                        return comment.id === parentCommentId
                            ? {
                                ...comment,
                                responses: comment.responses.map((response: { id: number; is_liked: any; total_likes: number; }) =>
                                    response.id === idComment
                                        ? {
                                            ...response,
                                            is_liked: !response.is_liked,
                                            total_likes: response.is_liked
                                                ? Math.max(0, response.total_likes - 1) // Evita valores negativos
                                                : response.total_likes + 1,
                                        }
                                        : response
                                )
                            }
                            : comment;
                    } else {
                        // Se for um comentário principal, atualiza normalmente
                        return comment.id === idComment
                            ? {
                                ...comment,
                                is_liked: !comment.is_liked,
                                total_likes: comment.is_liked
                                    ? Math.max(0, comment.total_likes - 1) // Evita valores negativos
                                    : comment.total_likes + 1,
                            }
                            : comment;
                    }
                })
            );

            await axios.post(url, {}, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

        } catch (err: any) {
            if (err.status == 401)
                setMessage(t("generics.errors.sessionExpired"), "error");

            if (err.response) {
                setMessage(err.response.data.message || "Erro ao comentar!", "error");
            } else if (err.request) {
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                setMessage("Ocorreu um erro inesperado!", "error");
            }

            if (err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

            if (err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");
            console.error(err);
        }
    }

    const clickEdit = (idComment: number, text: string) => {
        setIsEdditing(true)
        setText(text)
        setIdCommentEdit(idComment)
    }
    const cancelEdit = () => {
        // if(idCommentToResponse){
        //     setIdCommentToResponse(null)
        // }else{
        //     setIsEdditing(false)
        //     setText("")
        //     setIdCommentEdit(0)
        // }
        setIsEdditing(false)
        setText("")
        setIdCommentEdit(0)
        setIdCommentToResponse(null)
    }

    const handleSubmitComment = async (event: React.FormEvent<HTMLFormElement> | null, selectedGif?: string) => {
        event?.preventDefault(); // Impede o envio do formulário

        const gifUrl = selectedGif?.trim() || "";

        if (!text.trim() && !gifUrl) return;

        if(text && verifyLinks(text)){
            setMessage("Link suspeito, você não pode realizar esse comentário", "error");
            setLoading(false);
            return;
        }
        
        textareaRef.current?.blur();
        setDisabled(true);
        const isEdit = idCommentEdit && idCommentEdit > 0;
        const oldIdCommentEdit = idCommentEdit; 

        const oldText = text;
        var tempId = Date.now(); // ID temporário
        const newCommentData = {
            id_comment: idCommentToResponse || null, // ID temporário
            id: tempId, // ID temporário
            idNotSend: true,
            user: {
                img_account: user?.img_account, // Imagem do usuário autenticado
                name: user?.name, // Nome do usuário
                user_name: user?.user_name, // Nome do usuário
                verified_profile: user?.verified_profile, // Nome do usuário
                stamps: user?.stamps, // Nome do usuário
                position: user?.position, // Nome do usuário
            },
            textFormatted: text, // Texto do comentário
            gif_url: gifUrl || null,
            created_at: new Date().toISOString(), // Data do comentário
            can_edit: true, // Data do comentário
            can_delete: true, // Data do comentário
        };

        // Adiciona a resposta ao array `responses` do comentário correspondente
        if (idCommentToResponse && idCommentToResponse > 0) {
            setComments((prevComments) =>
                prevComments.map((comment) =>
                    comment.id === idCommentToResponse
                        ? {
                            responses: [newCommentData, ...(comment.responses || [])], // Adiciona a nova resposta
                            ...comment,
                        }
                        : comment
                )
            );
        } else if (!isEdit) {
            // Se não for uma resposta, adiciona como um novo comentário
            setComments((prevComments) => [newCommentData, ...prevComments]);
        } else {
            // Se for uma edição, atualiza o comentário existente
            tempId = idCommentEdit
            setComments((prevComments) =>
                prevComments.map((comment) =>
                        comment.id === tempId ? { ...comment, id: idCommentEdit, textFormatted: text, gif_url: gifUrl || null, idNotSend: true } : comment
                )
            );
        }

        cancelEdit()

        try {
            const formData = new FormData();
            formData.append("comment", text);
            if (gifUrl) formData.append("gif_url", gifUrl);
            if (idCommentToResponse && idCommentToResponse > 0)
                formData.append("id_original_comment", String(idCommentToResponse));

            const url = !isEdit ? (`${PACOCA_API_URL}/comments/${postId}`) : (`${PACOCA_API_URL}/comments/${idCommentEdit}`);
            var response: any;

            if (!isEdit) {
                response = await axios.post(url, formData, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
            } else {
                formData.append("text", text);
                formData.append("id_comment", idCommentEdit.toString());

                    response = await axios.patch(url, {
                        id_comment: idCommentEdit, comment: text, gif_url: gifUrl || null
                }, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
            }

            // Atualiza o estado com o ID real da resposta
            if (idCommentToResponse) {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === idCommentToResponse
                            ? {
                                ...comment,
                                total_responses: (comment.total_responses || 0) + 1, // Incrementa total_responses

                                responses: comment.responses?.map((responseItem: { id: number; }) =>
                                    responseItem.id === tempId
                                        ? { ...responseItem, id: response?.data?.comment?.id, idNotSend: false }
                                        : responseItem
                                ),
                            }
                            : comment
                    )
                );

                setExpandedComments(prev => ({
                    ...prev,
                    [idCommentToResponse]: true
                }));
            } else {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === tempId ? { ...comment, id: response?.data?.comment?.id, idNotSend: false } : comment
                    )
                );
            }
        } catch (err: any) {
            textareaRef.current?.blur();
            // Se houver erro, remove o comentário temporário
            if(!isEdit){
                setComments((prevComments) => prevComments.filter((comment) => comment.id !== tempId));
                setText(oldText);
                setDisabled(false);
            }
            else{
                clickEdit(oldIdCommentEdit, oldText)
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === tempId ? { ...comment, id: idCommentEdit, textFormatted: oldText, idNotSend: "error" } : comment
                    )
                );
            }

            if (err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if (err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

            if (err.status == 401)
                setMessage(t("generics.errors.sessionExpired"), "error");

            if (err.response) {
                setMessage(err.response.data.message || "Erro ao comentar!", "error");
            } else if (err.request) {
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                setMessage("Ocorreu um erro inesperado!", "error");
            }
            console.error(err);
        }
    };

    useEffect(() => {
        adjustTextareaHeight(); // Ajusta a altura ao montar o componente ou mudar o texto
        if (text.length <= LIMIT_TEXT_COMMENT && text.trim().length > 0) setDisabled(false)
        else setDisabled(true)
    }, [text]);


    const handlePinToggle = (commentId: number, pinned: boolean) => {
        setPinnedCommentIds((prev) =>
            pinned ? [...prev, commentId] : prev.filter((id) => id !== commentId)
        );
        setComments((prev) =>
            prev.map((c) => c.id === commentId ? { ...c, is_pinned: pinned } : c)
        );
    };

    useEffect(() => {
        setComments([]);
        setPinnedCommentIds([]);
        setOffset(0);
        setHasMore(true);
        loadData();
        loadPost();
    }, [postId]);

    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if (scrollTop + clientHeight >= scrollHeight - 50) {
                loadData();
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
            }
        };
    }, [loadData]);

    useEffect(() => {
        if (post?.text) {
            const modalCurtida = document.getElementById("modal-curtida");
            if (modalCurtida) {
                modalCurtida.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [post]);

    // const loadResponses = async (commentId: number) => {
    //     if (!comments.find(c => c.id === commentId)?.responses) {
    //         const url = `${PACOCA_API_URL}/comments/responses/${commentId}?limit=1&offset=${offset}`;
    //         // const url = `${PACOCA_API_URL}/comments/${commentId}/responses`;
    //         try {
    //             const response = await axios.get(url, {
    //                 headers: {
    //                     "Authorization": `Bearer ${token}`
    //                 }
    //             });

    //             setComments(prevComments => prevComments.map(comment =>
    //                 comment.id === commentId ? { ...comment, responses: response.data.comments } : comment
    //             ));
    //         } catch (error) {
    //             console.error("Erro ao carregar respostas:", error);
    //         } finally {
    //             setIsLoadingResponse(null)
    //         }
    //     }
    // };
    const loadResponses = async (commentId: number, offset: number = 0) => {
        const url = `${PACOCA_API_URL}/comments/responses/${commentId}?limit=${LIMIT_REQUEST_COMMENTS}&offset=${offset}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            setComments(prevComments => prevComments.map(comment =>
                comment.id === commentId
                    ? {
                        ...comment,
                        responses: offset === 0
                            ? response.data.comments // Se for a primeira carga, substitui as respostas
                            : [...(comment.responses || []), ...response.data.comments], // Adiciona novas respostas
                    }
                    : comment
            ));

            // Atualiza o offset para o próximo carregamento
            setResponsesOffset(prev => ({
                ...prev,
                [commentId]: offset + LIMIT_REQUEST_COMMENTS,
            }));
        } catch (error) {
            console.error("Erro ao carregar respostas:", error);
        } finally {
            setIsLoadingResponse(null);
        }
    };

    useEffect(() => {
        const handleModalClose = () => {
            setShow(false)
            setShowModalComments(false)
        };

        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    return (
        <div className="container container-feed container-comments" style={{ paddingTop: "76p60pxx", minWidth: "100%!important" }}>
            <NavbarPC />
            <div className="row row-screen-comments" style={{ justifyContent: "center", height: "100%" }}>
                <div className="col-md-4">
                    <div className="div-modal-curtida">
                        <div className="modal-dialog cover-mobile">
                            <div className="modal-content padding-modal-small-scroll" id="modal-content-body">
                                <div className="modal-body modal-body-comment-screen content-screen overflow-minus" id="modal-comments-body" style={{ background: "#fff", overflowY: "auto", overflowX: "hidden" }}>
                                    {post ? (
                                        <ViewPost setPost={setPost} onOpenComments={() => {setShowModalComments(true)}} onOpenLikes={() => { setShow(true); }} key={postId} post={post} />
                                    ) : null}

                                    <EditPost
                                        onEdit={(newText, gifUrl) => {
                                            // Atualizar o estado global da lista de posts
                                            setPost((preData) =>
                                                preData ? { ...preData, text: newText, gif_url: gifUrl ?? null } : null
                                            );

                                        }}
                                        post={post}
                                    />

                                    <div className="modal-header user-select-none" style={{ position: "sticky", top: "0px", zIndex: 3, backgroundColor: "red!important", width: "100%", marginRight: "-20px!important" }}>
                                        <ButtonBack />
                                        <h3 className="modal-title ml-5" id="modal-curtida">Comentários</h3>
                                    </div>

                                    <Helmet>
                                        <title>Paçoca - Comentários</title>
                                        <meta name="description" content="Paçoca, sua nova rede social." />
                                    </Helmet>

                                    <div style={{ minHeight: "calc(100dvh - 50px)" }}>
                                        {isLoading || isLoadingPost ? (
                                            <div className="row user-select-none row-empty">
                                                <LoadingThreeCircle style={{justifyContent: "center"}}/>
                                                {/* <Spinner className="text-primary" size="20" borderWidth="2" /> */}
                                            </div>
                                        ) : (
                                            <>
                                                <div style={{ minHeight: "calc(100dvh - 50px)" }}>
                                                    {[...comments].sort((a, b) => {
                                                        const aPin = pinnedCommentIds.includes(a.id) ? 1 : 0;
                                                        const bPin = pinnedCommentIds.includes(b.id) ? 1 : 0;
                                                        return bPin - aPin;
                                                    }).map((comment) => (
            
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <div key={comment.id} className="row card-comment" id="start-here" style={{ marginTop: "5px", marginRight: "-10px", marginLeft: "0px", }}>
                                                                {/* EDICAO E EXCLUSAO */}
                                                                {comment.can_edit || comment.can_delete || comment.can_pin ? (
                                                                    <div className="col-1 col-conf-post" style={{ position: "absolute", zIndex: 1 }}>
                                                                        <AnchoredDropdown>
                                                                            {comment.can_edit ? (
                                                                                <DropdownItem icon={<Edit size={15} className="icon-config-post" />} onClick={() => clickEdit(comment.id, comment.textFormatted)}>
                                                                                    Editar
                                                                                </DropdownItem>
                                                                            ) : null}
                                                                            {comment.can_delete ? (
                                                                                <DropdownItem icon={<Trash size={15} className="icon-config-post" />} danger onClick={() => handleDelete(comment.id)}>
                                                                                    Excluir
                                                                                </DropdownItem>
                                                                            ) : null}
                                                                            {comment.can_pin ? (
                                                                                <PinComment
                                                                                    commentId={comment.id}
                                                                                    postOwnerId={post?.id_user ?? 0}
                                                                                    isPinned={pinnedCommentIds.includes(comment.id)}
                                                                                    onToggle={handlePinToggle}
                                                                                />
                                                                            ) : null}
                                                                        </AnchoredDropdown>
                                                                    </div>
                                                                ) : null}

                                                                <img src={comment.user.img_account ? (BUCKET_PACOCA_URL + "/" + comment.user.img_account) : "/img/img-account.png"} className="user-select-none col-1 img-account-comment" onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />

                                                                <div className="col col-comment-text">
                                                                    <div className="comment-text">
                                                                        <div className="col-12 d-flex open-comment" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap", }}>
                                                                            <Link className="name-comment" to={`/@${comment.user.user_name}`}>
                                                                                {/* <span className="name-comment" onClick={() => comment.total_responses >0 ? toggleCommentExpansion(comment.id) : ""}> */}
                                                                                <h1 style={{ fontSize: "17px", marginBottom: 0 }}>
                                                                                    <span>
                                                                                        {comment?.user?.name || ''}
                                                                                        <ImgVerified user={comment.user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                                                                    </span>
                                                                                </h1>
                                                                            </Link>

                                                                            {pinnedCommentIds.includes(comment.id) ? (
                                                                                <div title={t("post.pinnedCommentLabel")} style={{ display: "flex", alignItems: "center", color: "var(--primary-blue, #f59e0b)", fontSize: "12px", gap: "2px" }}>
                                                                                    <Paperclip size={12} /> {t("post.pinnedCommentLabel")}
                                                                                </div>
                                                                            ) : null}
                                                                            <div>
                                                                                <p className="date-comment" style={{ marginBottom: 0 }}>{calculateTime(comment.created_at)}</p>
                                                                            </div>
                                                                        </div>
                                                                        <p className="text-comment open-comment" dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(comment.textFormatted), clearText) }}>
                                                                        </p>

                                                                        <div className="icons-config-comment user-select-none">
                                                                            <div className="response-icon-comment">
                                                                                {comment.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                                                            </div>
                                                                            <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(comment.id)}>
                                                                                {comment.total_likes} <Heart className={`${comment.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                                                            </div>
                                                                            {/* <div onClick={() => navigate(`/post/comentarios/respostas/${comment.id}`)} className="response-icon-comment cursor-pointer mt-1 d-flex" style={{ fontSize: "14px", alignItems: "center" }}> */}
                                                                            <div onClick={() => { setIdCommentToResponse(comment.id); setUserNameCommentToResponse(comment.user.name.split(" ")[0]); textareaRef.current?.focus() }} className="response-icon-comment cursor-pointer mt-1 d-flex" style={{ fontSize: "12px", alignItems: "center" }}>
                                                                                Responder
                                                                            </div>
                                                                        </div>
                                                                        {comment.idNotSend ? (
                                                                            <div className="d-flex w-100 div-status-comment" style={{ justifyContent: "right" }}>
                                                                                <Clock className={`comment-father-icon ${comment.idNotSend == "error" ? "comment-father-red" : ""}`} />
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {comment.total_responses > 0 && !comment.responses ? (
                                                                <div className="user-select-none cursor-pointer text-loading-comments" onClick={() => toggleCommentExpansion(comment.id)}>
                                                                    {isLoadingResponse == comment.id ? (
                                                                        <Spinner className="text-primary" />
                                                                    ) : (
                                                                        <>Carregar respostas</>
                                                                    )}
                                                                </div>
                                                            ) : null}

                                                            {expandedComments[comment.id] && comment.responses && (
                                                                <div className="">
                                                                    {comment.responses.map((originalComment: any) => (
                                                                        <div id="original-coment" className="responses-container row card-comment-open original-coment" style={{ marginTop: "5px", background: "var(--background-item)", paddingTop: "10px", borderRadius: "10px", position: "relative" }}>
                                                                            {originalComment.can_edit || originalComment.can_delete ? (
                                                                                <div className="col-1 col-conf-post" style={{ position: "absolute", zIndex: 1 }}>
                                                                                    <AnchoredDropdown>
                                                                                        {originalComment.can_edit ? (
                                                                                            <DropdownItem icon={<Edit size={15} className="icon-config-post" />} onClick={() => clickEdit(originalComment.id, originalComment.textFormatted)}>
                                                                                                Editar
                                                                                            </DropdownItem>
                                                                                        ) : null}
                                                                                        {originalComment.can_delete ? (
                                                                                            <DropdownItem icon={<Trash size={15} className="icon-config-post" />} danger onClick={() => handleDelete(originalComment.id, true, originalComment.id_comment)}>
                                                                                                Excluir
                                                                                            </DropdownItem>
                                                                                        ) : null}
                                                                                    </AnchoredDropdown>
                                                                                </div>
                                                                            ) : null}


                                                                            <img className="user-select-none col-1 img-account-likes img-account-comment" src={getImageUser(originalComment?.user?.img_account)} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                                                            {/* <div className="col-1 img-account-likes img-account-comment img-account-search img-account-view-search" style={{ backgroundImage: `url("${getImageUser(originalComment?.user?.img_account)}")` }}></div> */}
                                                                            <div className="col col-comment-text">
                                                                                <div className="comment-text">
                                                                                    <div className="col-12 d-flex" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap" }}>
                                                                                        <Link className="name-comment user-name-view-comment" to={`/@${originalComment?.user.user_name}`}>
                                                                                            <h1 style={{ fontSize: "17px", marginBottom: 0 }}>
                                                                                                <span>
                                                                                                    {originalComment?.user.name}
                                                                                                    <ImgVerified user={user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                                                                                </span>
                                                                                            </h1>
                                                                                        </Link>
                                                                                        <div>
                                                                                            <p className="date-comment date-comment-view-comment" style={{ marginBottom: 0 }}></p>
                                                                                            <p className="username-comment username-view-comment w-100">@{originalComment?.user.user_name}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <p dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(originalComment.textFormatted || " a"), clearText) }} className="text-comment text-comment-view-comment cursor-pointer">

                                                                                    </p>
                                                                                </div>
                                                                                <div className="icons-config-comment user-select-none">
                                                                                    <div className="response-icon-comment">
                                                                                        {originalComment?.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                                                                    </div>
                                                                                    <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(originalComment?.id ?? 0, true, originalComment.id_comment)}>
                                                                                        {originalComment?.total_likes} <Heart className={`${originalComment?.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {comment.responses && comment.total_responses > comment?.responses?.length ? (
                                                                <div className="user-select-none cursor-pointer text-loading-comments">
                                                                    {isLoadingResponse == comment.id ? (
                                                                        <Spinner className="text-primary" />
                                                                    ) : (
                                                                        <div onClick={() => loadResponses(comment.id, responsesOffset[comment.id] || 0)}>Carregar mais</div>
                                                                    )}
                                                                </div>
                                                            ) : null}



                                                        </div>
                                                    ))}

                                                    {post?.id && comments.length === 0 && (
                                                        <div className="user-select-none row row-empty-comment">
                                                            <span className="span-empty">
                                                                <MessageCircle className="icon-empty" />
                                                                <h3 className="w-100 text-center">Seja o primeiro a comentar</h3>
                                                            </span>
                                                        </div>
                                                    )}

                                                    {!post?.id && (
                                                        <div className="user-select-none row row-empty-comment">
                                                            <span className="span-empty">
                                                                <Trash className="icon-empty" />
                                                                <h3 className="w-100 text-center">Essa publicação foi apagada</h3>
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>



                                {!isLoading && post?.id && (
                                    <div className="modal-footer modal-footer-comment user-select-none">
                                        <div className="row row-comment" id="row-comment-{{$post?->id}}" style={{ width: "100%" }}>
                                            <div className="col" style={{ padding: 0 }}>
                                                {aiLimitBannerName ? <AiLimitBanner aiName={aiLimitBannerName} /> : null}
                                                <form className="form-comment" onSubmit={handleSubmitComment}>
                                                    {user?.email_verified_at ? (
                                                        <div className="d-flex">
                                                            <div style={{ width: "100%", padding: "5px" }}>
                                                                <textarea
                                                                    rows={1}
                                                                    ref={textareaRef}
                                                                    value={text}
                                                                    onChange={(e) => handleInputTextarea(e)}
                                                                    onKeyDown={(e) => handleKeyDown(e)}
                                                                    onFocus={() => handleFocusTextarea()}
                                                                    onBlur={() => handleBlurTextarea()}
                                                                    data-top-emoji="-60px"
                                                                    className="text-with-emoji textarea-new-comment form-control textarea-comment text-comment me-2"
                                                                    id="comment" name="comment"
                                                                    placeholder={userNameCommentToResponse ? `Responder ${userNameCommentToResponse}` : "Adicionar comentário"} required
                                                                />
                                                                
                                                                <EmojiPickerNative
                                                                    show={showEmoji}
                                                                    setShow={setShowEmoji}
                                                                    onSelect={(emoji) => setText(prev => prev + emoji)}
                                                                    handleClickGif={(gifUrl) => handleSubmitComment(null, gifUrl)}
                                                                    bottom="0"
                                                                />

                                                                <div className='div-info-textarea'>
                                                                    <div className='cursor-pointer icon-add-emoji' ref={buttonRef} onClick={() => setShowEmoji(true)}>
                                                                        <Smile className='icon-add-emoji' />
                                                                    </div>
                                                                    <div className="user-select-none limite-post" style={{ color: isLimitExceeded ? "red" : "inherit" }}>
                                                                        {text.length}/{LIMIT_TEXT_COMMENT}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <button onMouseDown={(e) => e.preventDefault()} onClick={(e) => e.stopPropagation()} className="btn btn-blue-send-comment button-submit-comment" disabled={disabled}>
                                                                <Send className="icon-send-comment" data-feather="send" />
                                                            </button>

                                                            {isEdditing || idCommentToResponse ? (
                                                                <button onClick={cancelEdit} className="btn btn-red-cancel-comment button-cancel-edit-comment" type="button" >
                                                                    <XSquare className="icon-send-comment" data-feather="x-square" />
                                                                </button>
                                                            ) : null}
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <p style={{ marginBottom: 10 }}>Verifique o email para comentar</p>
                                                            <FormVerifyEmail />
                                                        </>
                                                    )}
                                                </form>
                                            </div>
                                        </div>

                                        <div className="a" style={{ width: "100%", marginBottom: "5px" }}>
                                            <NavbarMobile />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <RepostWithText id_post={Number(postId)} />
            <ModalPostLikes idPostSelected={Number(postId)} show={show} />
            {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={Number(postId)}/> : <ModalComments idPostSelected={Number(postId)} show={showModalComments} />}
            
            <div id="is-navbar-static"></div> {/* permite que navbarbottom fica static */}
        </div>

    );
};

export default PostComments;
